"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  items?: FAQItem[];
}

const DEFAULT_FAQ_ITEMS: FAQItem[] = [
  {
    question: "How do I change my profile picture?",
    answer:
      "Click on the avatar above and select an image file. Supported formats are PNG, JPG, and WEBP with a maximum size of 5MB. You can drag and drop an image or click to select one.",
  },
  {
    question: "How do I update my email?",
    answer:
      "You can update your email in the profile form above. After changing your email, you'll need to verify the new email address.",
  },
  {
    question: "How do I contact support?",
    answer:
      "Use the Contact Us form above to send us a message. We'll get back to you as soon as possible.",
  },
];

export function FAQSection({ items = DEFAULT_FAQ_ITEMS }: FAQSectionProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">FAQ</h2>
      <Accordion type="multiple" className="w-full">
        {items.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger>{item.question}</AccordionTrigger>
            <AccordionContent>{item.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
